import reframe from 'nike-re-framejs';
import Immutable from 'immutable';
import * as live from './domain/live';
import { createClocksMap, registerClocksHandler, updateClocksMap } from '@/events/services/clocks';
import { nikeOneMiddlewares } from '@/common/util';

reframe.registerHandler('nikeone.live.overview.failure', nikeOneMiddlewares, n1 => clearLiveAfterDisconnect(n1));

reframe.registerHandler('nikeone.live.detail.failure', nikeOneMiddlewares, n1 => clearLiveAfterDisconnect(n1));

export function clearLiveAfterDisconnect(n1Db) {
    return n1Db
        .delete('live')
        .delete('liveTournaments')
        .delete('liveIdsByTime');
}

reframe.registerHandler('nikeone.tournamentSnapshot', nikeOneMiddlewares, (db, [snapshot]) => {
    db = live.processSnapshot(db, snapshot);
    return db.mergeIn(['clock'], createClocksMap(snapshot.filter(item => item.payload === 'MATCH').map(i => i.delta)));
});

reframe.registerHandler('nikeone.live.updateChannelStatus', nikeOneMiddlewares, (db, [channelData]) =>
    db.setIn(['liveChannels', channelData.channelId], Immutable.fromJS(channelData))
);

// betMessage a matchMessage nechceme logovat
reframe.registerHandler(
    'nikeone.matchMessage',
    [reframe.path(['nikeone'], Immutable.Map()), reframe.trimv],
    (db, [data, payloadEvent]) => {
        let resDb = db;
        if (payloadEvent === 'DELETED') {
            resDb = live.processMatchDeleted(db, data.boxId, data.matchId);
        } else if (payloadEvent === 'CREATED') {
            resDb = live.processMatchCreated(db, data.matchId, data.delta, data.version);
        } else {
            resDb = live.processMatchChanged(db, data.matchId, data.delta, data.version);
        }
        return resDb.updateIn(['clock'], Immutable.Map(), actualMap =>
            updateClocksMap(actualMap, payloadEvent, resDb.getIn(['live', data.matchId, 'match']))
        );
    }
);

reframe.registerHandler(
    'nikeone.betMessage',
    [reframe.path(['nikeone'], Immutable.Map()), reframe.trimv],
    (db, [data, payloadEvent]) => {
        if (payloadEvent === 'DELETED') {
            return live.processBetDeleted(db, data.matchId, data.betId);
        } else {
            return live.processBetCreatedOrChanged(db, data.matchId, data.betId, data.delta, data.version);
        }
    }
);

registerClocksHandler('nikeone.tick', ['nikeone', 'clock']);
